import { Suspense } from 'react';
import { createHashRouter } from 'react-router-dom';
import App from '../App';
import ErrorPage from '../pages/ErrorPage';
import RootRoute from '../components/RootRoute';
import {
  AdhocSettings,
  AdhocStatus,
  AdhocUploadFile,
  ApplicationDetails,
  ApplicationStatus,
  GenerateUploadTemplate,
  Templates,
  UploadTemplate,
  WorkflowSelection,
  ItemViewInfo,
  ItemViewSettings,
  ItemViewSetup,
  WorkflowIntro,
} from './lazy';

const SuspenseFallback = <div />;

export const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <RootRoute />,
      },
      {
        path: '/workflow-selection',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <WorkflowSelection />
          </Suspense>
        ),
      },
      {
        path: '/adhoc-settings',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <AdhocSettings />
          </Suspense>
        ),
      },
      {
        path: '/upload-template',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <UploadTemplate />
          </Suspense>
        ),
      },
      {
        path: '/application-details',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <ApplicationDetails />
          </Suspense>
        ),
      },
      {
        path: '/application-status/:id',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <ApplicationStatus />
          </Suspense>
        ),
      },
      {
        path: '/adhoc-upload-file',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <AdhocUploadFile />
          </Suspense>
        ),
      },
      {
        path: '/adhoc-application-status',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <AdhocStatus />
          </Suspense>
        ),
      },
      {
        path: '/generate/upload-template',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <GenerateUploadTemplate />
          </Suspense>
        ),
      },
      {
        path: '/generate/templates',
        element: (
          <Suspense fallback={SuspenseFallback}>
            <Templates />
          </Suspense>
        ),
      },
      {
        path: '/new-onboarding',
        children: [
          {
            path: 'settings',
            element: (
              <Suspense fallback={SuspenseFallback}>
                <ItemViewSettings />
              </Suspense>
            ),
          },
          {
            path: 'setup',
            element: (
              <Suspense fallback={SuspenseFallback}>
                <ItemViewSetup />
              </Suspense>
            ),
          },
          {
            path: 'info',
            element: (
              <Suspense fallback={SuspenseFallback}>
                <ItemViewInfo />
              </Suspense>
            ),
          },
          {
            path: 'workflow-intro',
            element: (
              <Suspense fallback={SuspenseFallback}>
                <WorkflowIntro />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
]);
